<template>
  <div>
    <!-- Case Detail -->
    <case-detail
      v-if="showCaseDetail"
      :caseInfo="mappedCases[caseIndex]"
    ></case-detail>
    <!-- Case list -->
    <case-list
      v-else
      :cases="mappedCases"
      :total="total"
      :loading="isLoading"
    ></case-list>
    <!-- Pagination -->
    <v-footer fixed color="transparent">
      <div class="mx-auto py-5">
        <v-pagination
          v-model="page"
          :length="pages"
          :hidden="pages==1 || showCaseDetail"
        ></v-pagination>
      </div>
    </v-footer>
  </div>
</template>

<script>
  import nameMixin from "@/mixins/name";

  export default {
    name:'Cases',

    mixins: [nameMixin],

    components: {
      /** view component for displaying case detail */
      CaseDetail: () => import('./components/CaseDetail.vue'),
      /** view component for displaying cases */
      CaseList: () => import('./components/CaseList.vue')
    },

    data() {
      return {
        page: 1,
        isLoading: false
      }
    },

    watch: {
      page() {
        this.fetchCases(true)
      }
    },

    computed: {
      showCaseDetail() {
        return !!this.$route.params.id
      },
      caseIndex() {
        return this.$route.params.id
      },
      cases() {
        return this.$store.getters['ror/cases']
      },
      pages() {
        return this.$store.getters['ror/pages']
      },
      total() {
        return this.$store.getters['ror/total']
      },
      mappedCases() {
        return this.cases.map(c => {
          return {
            id: c.id,
            patient: this.getPatientName(c.patient),
            title: c.health_concern,
            case_number: c.case_number,
            consultations: c.consultations.length,
            date: c.created_at
          }
        })
      }
    },

    async created() {
      await this.fetchCases()
      this.$store.commit('ror/setCaseId', this.caseIndex)
    },

    methods: {
      async fetchCases(update=null) {
        try {
          this.isLoading = true
          await this.$store.dispatch('ror/getCompletedCases', {page: this.page, update: update})
          console.log('[total]', this.total)
          console.log('[pages]', this.pages)
          console.log('[cases]', this.cases)
          console.log('[mappedCases]', this.mappedCases)
          this.isLoading = false
        }
        catch(e) {
          console.log('[error]', e)
          this.isLoading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>